/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*******************************************!*\
  !*** ./src/js/product-recommendations.js ***!
  \*******************************************/
/*
BG: This function uses the recommended products API by Shopify. We firstly pass over the product ID we want to display recommended on, and then for each result, request the product.card template to get the look.
*/
var recommendedProducts = function recommendedProducts() {
  //determine if the recommendProducts class section is present
  var recommended = document.querySelector('.js-recommended-products');
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recommended.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }
  //if it is....
  if (!!recommended) {
    //Get the productID from the data attribute
    var productID = parseInt(recommended.getAttribute('data-product-id'));

    //using that productID, query the recommended products API
    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(productID, "&limit=5")).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var products = _ref.products;
      //with the response, loop through each product.
      products.forEach(function (product, index) {
        //console.log(product.handle)
        //we run a second fetch to get the product card HTML markup
        fetch(window.Shopify.routes.root + "products/".concat(product.handle, "?view=card")).then(function (response) {
          return response.text();
        }).then(function (html) {
          var flickitySlider = recommended.querySelector('.flickity-slider');

          //if flickity isn't present, it might be that it's not being used at a particular size, so we drop it in the section anyways.
          if (flickitySlider) {
            flickitySlider.innerHTML += html;
          } else {
            recommended.innerHTML += html;
          }
          var productCardsRecommended = document.querySelectorAll('.js-recommended-products .product-card');
          productCardsRecommended.forEach(function (productCardR) {
            productCardR.classList.add('flex', 'flex-col', 'w-auto', 'js-scrollbar-carousel-card', 'mr-5');
          });

          //if last product, and we're using flickity....
          if (index === products.length - 1 && flickityPresent && flickitySlider) {
            //after a breif delay, re-init flickity.
            setTimeout(function () {
              var flkty = Flickity.data('.js-recommended-products');
              flkty.reloadCells();
              flkty.resize();
            }, 1000);
          }

          //for product cards, set max qty
          var maxQuantitySelect = document.querySelectorAll('.product-card-select[data-max-quantity]');
          maxQuantitySelect.forEach(function (element, index) {
            return element.addEventListener('change', function () {
              var optionQuantity = element.querySelector('option:checked').dataset.quantity;
              var inputQuantity = element.parentElement.querySelector('.input-quantity');
              var quantityItems = element.parentElement.querySelector('.quantity-items');
              var maxQuantityButton = element.parentElement.querySelector('.max-quantity-button');
              inputQuantity.value = 1;
              maxQuantityButton.remove();
              var newmaxQuantityButton = '<button type="button" class="max-quantity-button w-8 py-1 px-2 hover:bg-mid-grey transition ease-in-out" @click="productQuantity++; if(productQuantity > ' + optionQuantity + '){productQuantity = ' + optionQuantity + '}"><span class="w-3 h-3 block"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" /></svg></span></button>';
              quantityItems.insertAdjacentHTML('beforeend', newmaxQuantityButton);
            });
          });
        });
      });
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  }
};
recommendedProducts();
/******/ })()
;